module.exports = __webpack_public_path__ + "static/media/antigua-beaches-45.8e957f7a.jpg";